export default __webpack_public_path__ + "static/media/washerafter.280353b2.jpg";